// extracted by mini-css-extract-plugin
export default {"_dm-icon--read-only":"ReadOnlyIndicator__dm-icon--read-only__j0AWG","aria":"ReadOnlyIndicator_aria__CW7wl"};